import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { FadeUp } from "@/components/Reveal";
import { IMAGES } from "@/data/site";
import { useLang } from "@/i18n/LanguageContext";

const CTASection = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section
      ref={ref}
      data-testid="cta-section"
      className="hv-grain relative overflow-hidden bg-midnight"
    >
      <motion.img
        src={IMAGES.cta}
        alt={t.ctaSection.imgAlt}
        style={{ y }}
        loading="lazy"
        className="absolute inset-0 h-[120%] w-full object-cover"
      />
      <div className="absolute inset-0 bg-black/65" />

      <div className="relative z-10 mx-auto flex max-w-[1680px] flex-col items-center px-6 py-32 text-center lg:px-12 lg:py-48">
        <FadeUp>
          <h2 className="font-serif text-4xl font-light leading-[1.08] text-ivory md:text-5xl lg:text-6xl">
            {t.ctaSection.line1}
            <br />
            <span className="italic text-gold">{t.ctaSection.line2}</span>
          </h2>
        </FadeUp>
        <FadeUp delay={0.15}>
          <p className="mt-8 font-sans text-sm font-light tracking-[0.15em] text-ivory/70 md:text-base">
            {t.ctaSection.sub}
          </p>
        </FadeUp>
        <FadeUp delay={0.3}>
          <Link
            to="/quote"
            data-testid="cta-get-quote-btn"
            className="mt-12 inline-block bg-gold px-14 py-5 font-sans text-xs tracking-[0.3em] text-midnight transition-colors duration-300 hover:bg-gold-light"
          >
            {t.ctaSection.button}
          </Link>
        </FadeUp>
      </div>
    </section>
  );
};

export default CTASection;
